import React from 'react';
import { noop, get } from 'lodash';

// React view component to render
import { memberCommunicationSettings as MemberCommunicationSettingsView } from 'ui/views/widgets/memberCommunicationSettings';
import { MemberCommunicationSettingsService } from 'services/memberCommunicationSettings';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as pageLevelPreloader from 'modules/page-level-preloader';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberCommunicationSettings } from 'ui/containers/MemberCommunicationSettings';
 *
 * // render
 * <MemberCommunicationSettings propName='propValue'/>
 */
export class MemberCommunicationSettings extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods to instance
        this.addEditActionHandler = this.addEditActionHandler.bind( this );
        this.deleteActionHandler = this.deleteActionHandler.bind( this );
        this.defaultActionHandler = this.defaultActionHandler.bind( this );

        // Member Info Settings Service
        this.memberCommunicationSettingsService = new MemberCommunicationSettingsService();

    }

    /**************************************************** */

    // open add edit form as well as call Add or Edit functionality depends upon the action
    async addEditActionHandler( { action, mode, field } = {} ) {
        log.debug( 'MemberCommunicationSettings.addEditActionHandler()' );

        // cancel ongoing request
        this.memberCommunicationSettingsService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.memberCommunicationSettingsService.fetchAddEditForm( {
            url: action.url,
            data: this.props.requestPayload
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.ADD_EDIT_CONTACTS,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...data,
                    mode,
                    itemData: field,
                    onCancelClick: () => {
                        overlay.close();
                    },
                    onSumbitClick: async ( { id, type, contact } ) => {
                        overlay.close();
                        this.props.onAddEditClick( {
                            id,
                            type,
                            contact,
                            isDefault: get( field, 'flags.isDefault', false ),
                        } );
                    },
                }
            } );
        }
    }

    async deleteActionHandler( { item } ) {
        log.debug( 'MemberCommunicationSettings.deleteActionHandler()' );
        this.props.onDeleteClick( { item: item } );
    }

    async defaultActionHandler( { item } ) {
        log.debug( 'MemberCommunicationSettings.defaultActionHandler()' );
        this.props.onDefaultClick( { item } );
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberCommunicationSettingsView
                contacts= { this.props.contacts }
                options= { this.props.options }
                addAction= { this.props.addAction }
                modifyActions= {this.props.modifyActions }
                requestPayload={ this.props.requestPayload }
                deleteClickHandler={ this.deleteActionHandler }
                makeDefaultClickHandler={ this.defaultActionHandler }
                addEditClickHandler = { this.addEditActionHandler }
                actionClassName={ this.props.actionClassName }
                showDefaultButton={ this.props.showDefaultButton }
                disableAddNewButton={ this.props.disableAddNewButton }
            />
        );
    }
}

// set display name
MemberCommunicationSettings.displayName = 'MemberCommunicationSettings';

// set default props
MemberCommunicationSettings.defaultProps = {
    requestPayload: {},
    contacts: [],
    options: {},
    addAction: {},
    modifyActions: [],
    onDeleteClick: noop,
    onAddEditClick: noop,
    onDefaultClick: noop
};

// prop types
MemberCommunicationSettings.propTypes = {};
